<template>
  <div class="showcase-container">
    <div class="image-card shadow mb-5">
      <img
        alt="Product Image"
        :src="topImg"
        class="image"
      />
    </div>

    <b-card no-body class="description-card shadow p-3 mb-5">
      <b-card-body>
        <b-card-title>Still feel like you've collected everything except clarity?</b-card-title>

        <b-card-text>
          Are you ready to see a framework that simplifies, aligns, and brings direction to everything you already know?
        </b-card-text>

        <b-button href="https://pages.melanimethod.com/eoas-optin" target="_blank" pill variant="outline-dark">
          Join Now!
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import TopOfferImg from '@/assets/images/centre/top-offers/EOArchitectureTopPictureOffer.png';
export default {
  name: "PremiumTopOffer",
  data() {
    return {
      topImg: TopOfferImg,
    };
  },
  computed: {
    computedUrl() {
      return "/center/premium?category=Masterclasses&id=6";
    },
  },
};
</script>

<style scoped lang="scss">
/* ====GENERAL================================================== */
$dark-gray: #d9d9d9;
$light-gray: #e7e7e7;

.showcase-container {
  position: relative;
  height: 580px;
  margin-bottom: 4rem;
}

.image-card {
  z-index: 1;

  background-color: $dark-gray;
  border-radius: 1.5rem;
  margin-top: 2.5rem;

  display: flex;
  justify-content: center;

  .image {
    //height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 1.5rem;
  }
}

.card-body {
  padding: 3rem;
}

.description-card {
  top: -455px;
  left: 670px;
  z-index: 2;
  max-width: 350px;
  max-height: 300px;
  border-radius: 1.5rem;
  border: none;
  text-align: left;
  background-color: $light-gray;

  .card-title {
    font-weight: 700;
    font-size: 18px; //28px is the standard
  }

  .card-text {
    font-size: 12px;
    line-height: 1.2;
  }

  a.btn {
    background-color: white;
    border: none;
    font-weight: 700;
    padding: 6px 24px;

    &:hover {
      background-color: black;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1023) {
  .showcase-container {
    margin: 0;
  }
  .image-card {
    max-width: 738px;
  }
}

@media screen and (min-width: 769px) {
  .image-card {
    max-width: 690px;
  }
}

@media screen and (max-width: 768px) {
  .description-card {
    top: 0;
    max-width: 740px;
    max-height: 350px;
  }

  .showcase-container {
    height: auto;
  }
}

@media screen and (min-width: 769px) and (max-width: 992px) {
  .description-card {
    margin-top: 10px;
    margin-left: auto;
  }
}

@media screen and (max-width: 992px) {
  .description-card {
    left: 0;
  }
}
</style>
